module.exports = {"meta":{"count":40,"average":"4.2","reviewed":16,"limit":null,"sids":[],"averageAsInteger":4,"averageAsPercentage":84}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/reviews/hotels/meta/ABZ.json
// module id = 179
// module chunks = 119